<template>
  <div class="visualReport-container">
    <div class="dydl-wd">
      <div class="wd-container">
        <div class="map-radio">
              <span>{{$t('operate.name72')}}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{$t('operate.name74')}}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{$t('operate.name73')}}</el-radio>
        </div>
        <div class="baidu-map" v-show="mapchange === '1'">
          <!-- <div class="query-form"> -->
          <!-- <div class="gjsd">{{$t('operate.name75')}}<el-slider v-model="speedbaidu" style="width: 200px" :step="1" :min="10"></el-slider></div> -->
          <!-- <div>
            <el-button type="primary" @click="handleQuery">{{$t('operate.name77')}}</el-button>
            <el-button type="primary" @click="handPathStop">{{$t('operate.name78')}}</el-button>
          </div> -->
          <!-- </div> -->
           <div id="faultMapDiv" class="map" ></div>
        <!-- <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom='true' @ready="handleMap"> -->
              <!-- <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline> -->
              <!-- <bm-marker :position="startmarkerPointbaidu" :icon="startmarkericonbaidu"></bm-marker> -->
              <!-- <bm-marker :position="markerPointbaidu" :icon="pointsmarkericon1"></bm-marker> -->
              <!-- <bml-lushu
                @stop="reset"
                :speed="speedbaidu*5"
                :path="pathbaidu"
                :icon="pointsmarkericon1"
                :play="playbaidu">
              </bml-lushu> -->
            <!-- </baidu-map> -->
            <div class="address">
              {{ address }}
            </div>
        </div>
        <div class="gooles-map" v-show="mapchange === '2'">
          <!-- <template>
            <el-form ref="queryForm" :inline="true"  class="">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="轨迹速度：">
                    <el-slider v-model="speed" style="width: 200px" :step="1" :min="10"
                               :input="inputspeed(speed)"></el-slider>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item style="float: left">
                    <el-button icon="el-icon-video-play" size="mini" @click="bikePolyLinestart">开始</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template> -->
            <!-- <div class="query-form">
          <div class="gjsd">{{$t('operate.name75')}}<el-slider v-model="speed" style="width: 200px" :step="1" :min="10"  :input="inputspeed(speed)"></el-slider></div>
          <el-button icon="el-icon-video-play"  @click="bikePolyLinestart" style="width: 100px">{{$t('operate.name76')}}</el-button>
            </div> -->
          <GmapMap :center='markerPoint' :zoom='20' ref="mapRef" class="map" id="mapps">
            <gmap-marker
              @click="bikePolyLine"
              :position="startmarkerPoint"
              :icon="startmarkericon">
            </gmap-marker>
            <gmap-marker
              :position="endmarkerPoint"
              :icon="endmarkericon">
            </gmap-marker>
          </GmapMap>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import { BmlLushu } from 'vue-baidu-map'
// import coordtransform from 'coordtransform'
export default {
  props: {
    itemdata: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    // BmlLushu
  },
  data() {
    return {
      topData: {},
      loading: false,
      dialogVisible: false,
      caution: require('@/assets/caution.png'),
      lineChart1: null,
      lineChart2: null,
      blData: [],
      blLabel: '',
      typeOptions: [],
      mapchange: '1',
      car_animate: null,
      count: 0,
      count2: 0,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      pointsmarkericon: {
        url: require('@/assets/caution.png'),
        size: {
          width: 16,
          height: 16
        },
        opts: {
          imageSize: {
            width: 16,
            height: 16
          }
        }
      },
      pointsmarkericon1: {
        url: require('@/assets/caution.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      BMap: null,
      map: null,
      pointsMarker: [],
      path: [],
      bikePath: [],
      speed: 0,
      speedbaidu: 30,
      pathbaidu: [],
      playbaidu: true,
      clickIndex: -1,
      queryInfo: {
        searchTime: [],
        ebikeId: ''
      },
      tableList: [],
      xWDData: [],
      yWDData1: [],
      yWDData2: [],
      yWDData3: [],
      xDLDYData: [],
      yDLDYData1: [],
      yDLDYData2: [],
      xSDGLData: [],
      ySDGLData1: [],
      ySDGLData2: [],
      xBLData: [],
      yBLData: [],
      bLLegend: [],
      address: '',
      dataTime: '',
      pickerMinDate: '',
      maxDate: null,
      minDate: null,
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('public.name49'),
            onClick: (picker) => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 6 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {},
  mounted() {
    this.getlngLatAlt()
  },
  beforeDestroy() {},
  methods: {
    reset () {
      this.playbaidu = false
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      map.disableDragging()
      this.getlngLatAlt()
    },
    getlngLatAlt() {
      const that = this
      this.path = []
      this.pathbaidu = []
      this.tableList = []
      this.bikePath = []
      this.pointsMarker = []
      this.startmarkerPointbaidu = { lng: 0, lat: 0 }
      this.endmarkerPointbaidu = { lng: 0, lat: 0 }
      const lngAndLat = this.itemdata.faultAddr.split(',')
      // const bikepoints = coordtransform.wgs84togcj02(lngAndLat[0], lngAndLat[0])
      // const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
      // this.pathbaidu.push({ lng: Number(bikepointss[0]), lat: Number(bikepointss[1]) })
      this.pathbaidu.push({ lng: lngAndLat[0], lat: lngAndLat[1] })
      if (this.pathbaidu) {
        this.markerPointbaidu.lng = this.pathbaidu[0].lng
        this.markerPointbaidu.lat = this.pathbaidu[0].lat
        that.T = window.T // 这个一定需要定义，可以直接在mounted里面定义
        let mapTD = null
        mapTD = new that.T.Map('faultMapDiv', {
          attributionControl: true,
          inertia: true
        })
        mapTD.centerAndZoom(new that.T.LngLat(this.markerPointbaidu.lng, this.markerPointbaidu.lat), 18)
        const control = new that.T.Control.Zoom()
        mapTD.addControl(control)
        var marker = new that.T.Marker(new that.T.LngLat(that.markerPointbaidu.lng, that.markerPointbaidu.lat), {
          icon: new that.T.Icon({
            iconUrl: that.caution,
            iconSize: new that.T.Point(30, 30)
          })
        })
        mapTD.addOverLay(marker)
        var geocode = new that.T.Geocoder()
        // var lnglat = { lat: parseFloat(this.markerPointbaidu.lat), lng: parseFloat(this.markerPointbaidu.lng) }
        // console.log('====', lnglat)
        const point = new that.T.LngLat(this.markerPointbaidu.lng, this.markerPointbaidu.lat)
        geocode.getLocation(point, function (result) {
          console.log('====', result)
          if (result.status === '0') {
            that.address = result.formatted_address
          }
        })

        // const geoc = new this.BMap.Geocoder()
        // const pt = new this.BMap.Point(this.markerPointbaidu.lng, this.markerPointbaidu.lat)
        // geoc.getLocation(pt, (rs) => {
        //   console.log('rs==', rs)
        //   if (rs.surroundingPois.length) {
        //     this.address = rs.surroundingPois[0].address
        //   } else {
        //     this.address = rs.address
        //   }
        // })
      }
    },
    handleQuery () {
      this.playbaidu = true
      this.markerPointbaidu.lng = 0
      this.markerPointbaidu.lat = 0
      setTimeout(() => {
        this.map.setZoom(20)
        this.markerPointbaidu.lng = this.pathbaidu[0].lng
        this.markerPointbaidu.lat = this.pathbaidu[0].lat
        this.markerPointbaidu = { lng: this.markerPointbaidu.lng, lat: this.markerPointbaidu.lat }
      }, 100)
    },
    handPathStop () {
      this.playbaidu = false
    },
    bikePolyLine () {
      var lineSymbol = {
        path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: '#FFF',
        strokeColor: '#FFF',
        scale: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.8
      }
      this.stratbikemaker()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.flightPath = new this.google.maps.Polyline({
          path: this.path,
          strokeColor: '#275aff',
          icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5%'
          }],
          strokeOpacity: 0.8,
          strokeWeight: 10
        })
        this.flightPath.setMap(map)
      })
    },
    bikePolyLinestart () {
      clearInterval(this.car_animate)
      this.car_animate = setInterval(() => {
        this.markerBlack.setIcon(this.pointsmarkericon)
        this.markerBlack.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count === this.path.length) {
          this.markerBlack.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this.car_animate)
        }
      }, (1 / this.speed) * 7000)
    },
    inputspeed (speed) {
      this.speed = speed
    },
    mapchangeradio() {
      if (this.mapchange === '1') {
        this.getlngLatAlt()
      } else {
        // this.path = []
        // this.bikePath.forEach((item) => {
        //   if (this.chinascope(item.lng, item.lat) === true) {
        //     const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
        //     this.path.push({
        //       lng: Number(bikepoint[0]),
        //       lat: Number(bikepoint[1])
        //     })
        //   } else {
        //     this.path.push({
        //       lng: Number(item.lng),
        //       lat: Number(item.lat)
        //     })
        //   }
        // })
        // this.markerPoint.lng = this.path[0].lng
        // this.markerPoint.lat = this.path[0].lat
        // this.startmarkerPoint.lng = this.path[0].lng
        // this.startmarkerPoint.lat = this.path[0].lat
        // this.endmarkerPoint.lng = this.path[this.path.length - 1].lng
        // this.endmarkerPoint.lat = this.path[this.path.length - 1].lat
        // setTimeout(() => {
        //   this.bikePolyLine()
        // }, 100)
      }
    },
    chinascope(lng, lat) {
      if (lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.visualReport-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .top-ds{
    width: calc(100% - 30px);
    display: flex;
    justify-content: space-between;
    height: 100px;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding: 0px 15px;
    .item{
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;
      .label{
        font-size: 18px;
        font-weight: 700;
      }
      .value{
        font-family: 'D-DIN-PRO-700';
        font-size: 18px;
      }
      .margin-top10{
        margin-top: 10px;
      }
    }
  }
  .margin-top20{
    margin-top: 20px;
  }

  .map-radio{
    display: flex;
    z-index: 999;
    position: absolute;
    left: 50px;
    top: 15px;
    align-items: center;
  }

  .writing-mode{
    writing-mode: vertical-rl;
    }

  .dydl-wd {
    width: 100%;
    display: flex;
    flex-direction: row;
    .dydl-container{
      position: relative;
      width:50%;
      display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
     border: 1px solid #f1f1f1;
     padding: 10px;
    }
    .dydl {
      width:100%;
      height: 400px;
    }
    .bll-select{
      width: 180px;
      margin-left: 20px;
      position: absolute;
      left: 0;
      top: 10px;
      display: flex;
      z-index: 999;
      justify-content: space-between;
      align-items: center;
    }

    .wd-text{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 600;
     }

    .dcdy{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #42bf7c;
      font-weight: 600;
     }

     .dcdl{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #5a7ff1;
      font-weight: 600;
     }
     .gz-table{
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 400px;
      padding: 10px;
      .title{
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .row1{
        width: 30%;
        padding-left: 10px;
      }
      .row2{
        width: 20%;
      }
      .row3{
        width: 30%;
      }
      .row4{
        width: 20%;
      }
      .icon{
        width: 25px;
        height: 25px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .table-title{
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 600;
        padding: 10px 0px;
        border-bottom: 1px solid #f1f1f1;
      }
      .table-content{
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 360px;
        overflow: auto;
        margin-top: 10px;
      }
      .nodata{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .item-content-active{
        background: #f1f1f1;
      }
      .item-content{
        width: 100%;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        padding: 10px 0px;
        align-items: center;
      }
     }

     .margin-left15{
      margin-left: 15px;
     }

     .wd-container{
      position: relative;
      width: 100%;
      display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
     padding-right: 10px;
    .wd {
      width: 100%;
      height: 400px;
    }
  }
  }
  .baidu-map{
    width: 100%;
    position: relative;
  }
  .address{
    z-index: 9999;
    position: absolute;
    bottom: 0;
    right: 0;
    font-weight: 800;
  }
  .gooles-map{
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .map{
    width: 100%;
    height: 420px;
  }
  .el-icon-rank{
    font-size: 24px;
    color: black;
    position: absolute;
    bottom: 15px;
    right: 15px;
    z-index: 999;
    cursor: pointer;
  }
  .full-map{
    .map{
      width: 100%;
      height: 800px;
    }
    .query-form{
      display: flex;
    flex-direction: column;
    z-index: 999;
    position: absolute;
    top: 80px;
    left: 20px;
    .gjsd{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    }
  }
  .query-form{
    display: flex;
    flex-direction: column;
    z-index: 999;
    position: absolute;
    top: 20px;
    left: 20px;
    .gjsd{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .input {
    width: px2vw(147);
  }
  .form-item2 {
    margin-left: px2vw(-15);
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
}
</style>
